export enum TabValue {
	Recommendations = "Recommendations",
	Chat = "Chat",
	Requests = "Requests",
	MedicalDepartmentRequests = "MedicalDepartmentRequests",
	TimeOffRequests = "TimeOffRequests",
	ChatBot = "Annie",
	Summary = "Summary",
}
